import { render, staticRenderFns } from "./FieldType23.vue?vue&type=template&id=07d09874&scoped=true"
import script from "./FieldType23.vue?vue&type=script&lang=js"
export * from "./FieldType23.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d09874",
  null
  
)

export default component.exports